<div class="calendar-container">
  <div class="calendar-body">
    <!-- Left Arrow -->
    <button class="nav-arrow" 
    (click)="prevMonth()">
      <i [class.disabled] = "isPrevMonthDisabled" class = "fa fa-chevron-left"></i>
    </button>

    <!-- Two-Month View -->
    <div class="months">
      <ng-container *ngFor="let month of calendarMonths">
        <div class="month">
          <h3>{{ month.month }} {{ month.year }}</h3>

          <div class="days-grid">
            <!-- Weekday Labels -->
            <div class="day-label" *ngFor="let d of ['S','M','T','W','T','F','S']">
              {{ d }}
            </div>

            <!-- Leading empty cells for first day -->
            <div
              class="day empty"
              *ngFor="let _ of getOffsetArray(month.month, month.year)"
            ></div>

            <!-- Actual Dates -->
            <div
              class="day"
              *ngFor="let dateObj of month.dates"
              (click)="handleDateClick(month.month, dateObj.date.date())"
              [class.disabled]="dateObj.disabled"
              [class.selected]="isDateSelected(month.month, dateObj.date.date())">
              {{ dateObj.date.date() }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Right Arrow -->
    <button class="nav-arrow" (click)="nextMonth()">
      <i class = "fa fa-chevron-right"></i>
    </button>
  </div>
</div>
